module.exports = __webpack_public_path__ + "src/assets/img/icone_rotate2.6e908d4e.svg";